export const QA_NAME_APPLICANT_CHECKLIST = 'applicantDocumentChecklist'

export const QA_NAME_APPLICANT_CHECKLIST_REJECT = 'applicantDocumentReject'

export const QA_NAME_APPLICANT_CHECKLIST_STATUS = 'applicantDocumentStatus'

export const QA_NAME_APPLICANT_CHECKLIST_REJECT_MODAL =
  'applicantDocumentRejectModal'

export const QA_NAME_APPLICANT_CHECKLIST_REJECT_REASON =
  'applicantDocumentRejectReason'

export const QA_NAME_APPLICANT_CHECKLIST_VERIFY = 'applicantDocumentVerify'

export const QA_NAME_APPLICANT_CHECKLIST_ATTACH = 'applicantDocumentAttach'

export const APPLICANT_CHECKLIST_COLUMN_TITLE_KEYS = [
  'RentalPortal.ApplicantDocumentTypeColumnKey',
  'RentalPortal.ApplicantDocumentStatusColumnKey',
  'RentalPortal.ApplicantDocumentFileColumnKey',
  'RentalPortal.ApplicantDocumentDateColumnKey',
]

export const APPLICANT_CHECKLIST_CREDIT_REPORT_KEY = 'credit_report'

export const APPLICANT_CREDIT_REPORT_DOCUMENT_OPTIONS = [
  {
    label: 'RentalPortal.ApplicantDocumentSchufaKey',
    value: 'schufa_bonitaetscheck',
  },
  {
    label: 'RentalPortal.ApplicantDocumentKsvInfopassKey',
    value: 'ksv_infopass',
  },
  {
    label: 'RentalPortal.ApplicantDocumentCrifMieterCheckKey',
    value: 'crif_mieter_check',
  },
  {
    label: 'RentalPortal.ApplicantDocumentBetreibungsregisterKey',
    value: 'betreibungsregisterauszug',
  },
]

export const APPLICANT_CHECKLIST_ATTACH_UPLOAD_OPTIONS = {
  maxFiles: 1,
  multiple: false,
}

export const APPLICANT_DOCUMENT_STATUS = {
  missing: 'missing',
  rejected: 'rejected',
  uploaded: 'uploaded',
  verified: 'verified',
}

export const APPLICANT_DOCUMENT_STATUS_LABEL_KEY = {
  [APPLICANT_DOCUMENT_STATUS.missing]:
    'RentalPortal.ApplicantDocumentStatusMissingKey',
  [APPLICANT_DOCUMENT_STATUS.rejected]:
    'RentalPortal.ApplicantDocumentStatusRejectedKey',
  [APPLICANT_DOCUMENT_STATUS.uploaded]:
    'RentalPortal.ApplicantDocumentStatusUploadedKey',
  [APPLICANT_DOCUMENT_STATUS.verified]:
    'RentalPortal.ApplicantDocumentStatusVerifiedKey',
}

export const APPLICANT_DOCUMENT_STATUS_TEXT_COLOR = {
  [APPLICANT_DOCUMENT_STATUS.missing]: 'var(--secondary-text-color)',
  [APPLICANT_DOCUMENT_STATUS.rejected]: 'var(--color-error)',
  [APPLICANT_DOCUMENT_STATUS.uploaded]: 'var(--color-info)',
  [APPLICANT_DOCUMENT_STATUS.verified]: 'var(--color-success)',
}

export const APPLICANT_CHECKLIST_REJECT_REASON_MAX_LENGTH = 500
